<template>
  <!-- 绑定客户 -->
  <div class="bindUser">
    <!-- 面包屑导航 -->
    <page-bar @back="goBack" @refresh="handleRefresh" :title="$route.meta.title">
      <template slot="controls">
        <el-button type="primary" icon="el-icon-circle-plus-outline"
          @click="getDataList('')">绑定账号</el-button>
        <el-button type="danger" icon="el-icon-delete"
          :disabled="selectedList.length == 0" @click="bindUser('','DLT')">批量删除</el-button>
      </template>
    </page-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input v-model="searchForm.name" style="width: 200px; margin-right: 5px" clearable 
          placeholder="输入编号/名称" @keyup.enter.native="getTableData(1)"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)">搜索</el-button>
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe border
      height="calc(100% - 130px)"
      :row-style="{color:'#303133'}"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%">
      <el-table-column
        type="selection"
        align="center"
        width="55">
      </el-table-column>
      <el-table-column
        label="序号"
        align="center"
        width="50">
        <template slot-scope="scope">
          <span>{{(currPage - 1) * pageSize + scope.$index + 1}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="id"
        align="center"
        show-overflow-tooltip
        label="客户编号">
      </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        show-overflow-tooltip
        label="单位名称">
      </el-table-column>
      <el-table-column
        label="操作"
        align="center">
        <template slot-scope="scope">
          <el-button type="danger" style="padding:2px 3px;" plain
            @click="bindUser(scope.row.id, 'DLT')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination :allPage="allPage" :pageSize="pageSize" :currIndex="currPage"
      @hanSiChange="hanSiChange" @hanCurrChange="hanCurrChange"></pagination>

    <!-- 数据选择 -->
    <tableDialog 
      v-if="dialogVisible"
      title="数据选择"
      :isMoreSel="true"
      :searchValue="searchData.name"
      :tableData="tableList"
      :tableHead="tableHead"
      :currPage.sync="currPageData"
      :allPage="allPageData"
      @search="getDataList"
      @moreSel="selDataOk"
      @rowClick="rowClick"
      @hanCurrChange="hanChangeData"
      @close="dialogVisible = false"
    ></tableDialog>
  </div>
</template>

<script>
//表单验证
// import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: 'bindUser',
  data() {
    return {
      id: '',
      /**表格数据 */
      tableData: [],
      searchForm: {
        name: ''
      },
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      selectedList: [],
      // 数据选择
      dialogVisible: false,
      searchData: {
        name: ''
      },
      tableList: [],
      tableHead: {},
      currPageData: 1,
      allPageData: 0,
    }
  },
  mounted(){
    if(this.$route.query.prams){
      let prams = JSON.parse(decodeURIComponent(this.$route.query.prams))
      if(prams){
        this.id = prams.id
        this.getTableData()
      }
    }
  },
  methods:{
    updata(){
      if(this.id){
        this.getTableData()
      }
    },
    goBack() {
      this.$router.go(-1);
      this.$destroy()
    },
    /**获取表格 */
    getTableData(num){
      this.currPage = num == 1 ? 1 : this.currPage
      let data = {
        userId: this.id,
        entId: window.localStorage.getItem('entId'),
        searchType: "Correlation",
        sqlValue: this.searchForm.name,
        pageIndex: this.currPage,
        pageSize: this.pageSize,
      }
      this.$request({
        url: 'Member/GetUsersCorrelationList',
        method: "post",
        data: data
      }).then((res) => {
        this.tableData = []
        this.allPage = res.toTal
        if (res.success) {
          this.tableData = res.list.map(item => ({
            id: item.userid.trim(),
            name: item.businessName,
          }))
        }
      }).catch((err) => {
        window.console.log(err);
      });
    },
    /**刷新表格数据 */
    handleRefresh(){
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val){
      this.pageSize = val;
      this.getTableData()
    },
    /**当前页改变 */
    hanCurrChange(val){
      this.currPage = val;
      this.getTableData()
    },
    /**selection change触发事件 */
    selectionChange(section){
      //存放选中的表格数据
      this.selectedList = section;
    },

    // 获取弹出框表格数据
    getDataList(val,isRep){
      this.searchData.name = isRep ? val : this.searchData.name
      let data = {
        userId: this.id,
        entId: window.localStorage.getItem('entId'),
        searchType: "NoCorrelation",
        sqlValue: this.searchData.name,
        pageIndex: this.currPageData,
        pageSize: 10,
      }
      this.$request({
        method:"post",
        url: 'Member/GetUsersCorrelationList',
        data: data
      }).then((res) => {
        if (res.success) {
          this.tableList = res.list.map(item => ({
            id: item.userid.trim(),
            name: item.businessName,
          }))
          this.tableHead = { id: '用户编号', name: '单位名称' }
          this.allPageData = res.toTal
          this.dialogVisible = true
        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }).catch((err) => {
        window.console.log(err)
      })
    },
    /**当前页改变 */
    hanChangeData(val){
      this.currPageData = val
      this.getDataList()
    },
    // 选择单条数据
    rowClick(row){
      this.selDataOk([row])
    },
    // 选择数据完成，多选
    selDataOk(selectedList){
      if(selectedList.length == 0){
        this.$message({
          message: '请选择数据',
          type: 'warning'
        })
        return
      }
      let id = selectedList.map(item => item.id).join(',')
      this.bindUser(id, 'ADD')
    },
    /**点击绑定或删除客户 */
    bindUser(id, type){
      let msg = '确定绑定吗?'
      let msgType = 'success'
      if(type == 'DLT'){
        id = id || this.selectedList.map(item => item.id).join(',')
        msg = '确定删除吗?'
        msgType = 'error'
      }
      this.$confirm(msg, '提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: msgType
      }).then(() => {
        let data = {
          userId: this.id,
          correlationId: id,
          operationType: type
        }
        this.$request({
          method: "post",
          url: 'Member/UserCorrelation',
          data: data
        }).then((res) => {
          if (res.success) {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.dialogVisible = false
            this.getTableData()
          } else {
            this.$message({
              message: res.message,
              type: 'error'
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.bindUser{
  width: 100%;
  height: 100%;
}
</style>
